/**
 * Staff Reset Password Page
 * Allows users to set a new password using a reset token from email
 */

import { ResetPassword } from '@/components/auth/ResetPassword';

export default function StaffResetPasswordPage() {
  return <ResetPassword />;
}
